/**
 * @hidden
 */
var BaseEvent =
/** @class */
function () {
  /**
   * @hidden
   */
  function BaseEvent(target) {
    this.target = target;
  }

  return BaseEvent;
}();

export { BaseEvent };